import React, { useCallback, useEffect, useState } from "react"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { Template } from "../../Components/Template/template"
import { AlertType, classBorderLabelDark, classbtCeuAzul, classbtCinzaClaro, classbtColunasAzul, classBtSemDuration, classDivBackground, classDivBody, classDivTitulo, classInput, classInputDark, classLabel, classLabelDark, Grupo, Marca, ProdAttributes, Produto, ProdutoEstoque } from "../../Utils/Types"
import { HiOutlineClipboardDocumentList } from "react-icons/hi2"
import { IoCloseCircleOutline, IoPrint, IoSearch } from "react-icons/io5"
import { SearchBox } from "../../Components/SearchBox/SearchBox"
import { AiOutlineClear } from "react-icons/ai"
import { GridProductsEstoque } from "../../Components/GridProducts/GridProductsEstoque"
import { ProdutoService } from "../Products/ProdutoService"
import { Icone } from "../../Components/Icones/Index"
import { faFilter } from "@fortawesome/free-solid-svg-icons"
import { RelProdutosEstoquePDF } from "./pdf/rel-products-estoque"
import { Funcoes } from "../../Utils/Funcoes"

type produtosFilter = {
    id_marca: number,
    id_grupo: number,
    tipo_estoque: string,
    status: string,
}

export const RelatorioEstoqueProduto = () => {

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS FILTRO -------------------------------------------
    const [field, setField] = useState('descricao')
    const [filterType, setFilterType] = useState('start')
    const [filter, setFilter] = useState('')

    // ---------- ATRIBUTOS FILTRO AVANÇADO ---------------------------------------------------
    const [marcas, setMarcas] = useState<Marca[]>([])
    const [idMarca, setIdMarca] = useState(0)
    const [nomeMarca, setNomeMarca] = useState('')

    const [grupos, setGrupos] = useState<Grupo[]>([])
    const [idGrupo, setIdGrupo] = useState(0)
    const [nomeGrupo, setNomeGrupo] = useState('')

    const [ativo, setAtivo] = useState("")
    const [estoqueFisico, setEstoqueFisico] = useState("")

    const [relatorioFilter, setRelatorioFilter] = useState<produtosFilter>({ id_grupo: 0, id_marca: 0, status: '', tipo_estoque: '' })

    const [totalProdutos, setTotalProdutos] = useState('0')
    const [totalPrecoVenda, setTotalPrecoVenda] = useState('0')
    const [totalPrecoCusto, setTotalPrecoCusto] = useState('0')


    // ---------- ATRIBUTOS GRID ------------------------------------------------
    const [produtosEstoque, setProdutosEstoque] = useState<ProdutoEstoque[]>([])
    const [prodAttributes, setProdAttributes] = useState<ProdAttributes>()


    // ---------- ATRIBUTOS SEARCHBOX -------------------------------------------
    const [visibleSearchBoxMarca, setVisibleSearchBoxMarca] = useState<boolean>(false)
    const [visibleSearchBoxGrupo, setVisibleSearchBoxGrupo] = useState<boolean>(false)

    //-------------------------------------------------------------------- REQUISIÇÃO API, ATALHOS E FOCUS ---------------------------------------------------------------------//
    const getProdutos = async () => {

        setLoading(true)

        try {

            const attributes = await ProdutoService.GetAttributes()
            setProdAttributes(attributes.data)

            if (attributes) {
                setGrupos([...attributes.data.grupos])
                setMarcas([...attributes.data.marcas])
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar as informações`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 0)
        }
    }

    const searchBoxFocus = () => {
        setVisibleSearchBoxGrupo(false)
        setVisibleSearchBoxMarca(false)
    }

    useEffect(() => {
        getProdutos()
    }, [])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

    }, [])

    const handleKeyPressEnter = async (e: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroProd") as HTMLDivElement

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !visibleSearchBoxMarca && !visibleSearchBoxGrupo && !loading && menuFiltro.classList.contains("max-h-[600px]")) {
            await handleFilterClick()
        }
    }

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPress)
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {

            document.removeEventListener('keydown', handleTabPress)
            document.removeEventListener('keydown', handleKeyPressEnter)
        }
    }, [filter, filterType, field, idMarca, idGrupo, estoqueFisico, ativo, visibleSearchBoxMarca, visibleSearchBoxGrupo, loading])

    useEffect(() => {
        getProdutos()
    }, [])

    const inputFocus = () => {
        const inputElement = document.getElementById("pesquisa_produto_estoque")
        inputElement?.focus()
    }

    //-------------------------------------------------------------------- FILTROS  -------------------------------------------------------------------------//
    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroProdEstoque") as HTMLDivElement

        //let menuControl = document.getElementById("divMenuControlProd") as HTMLDivElement

        let menuInputs = document.getElementById("divInputsProdEstoque") as HTMLDivElement

        searchBoxFocus()

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[600px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            //menuControl.classList.toggle("rounded-md")
            //menuControl.classList.toggle("rounded-t-md")

            if (menuFiltro.classList.contains("max-h-[600px]")) {

                //menuControl.classList.remove("rounded-md")
                //menuControl.classList.add("rounded-t-md")
                //setSearchBoxResponsivo(true)

                menuInputs.classList.remove("invisible")

                const timer = setTimeout(() => {
                    inputFocus()
                    clearTimeout(timer)
                }, 150)


            } else {
                //menuControl.classList.add("rounded-md")
                //menuControl.classList.remove("rounded-t-md")
                //setSearchBoxResponsivo(false)

                menuInputs.classList.add("invisible")

            }

            event.currentTarget.blur()
        }
    }

    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)
        setProdutosEstoque([])
        searchBoxFocus()

        try {

            const relatorio = {
                id_marca: idMarca,
                id_grupo: idGrupo,
                tipo_estoque: estoqueFisico,
                status: ativo,
            }

            setRelatorioFilter(relatorio)

            const produtos = await ProdutoService.FilterEstoque(field, filter, filterType, relatorio)
            console.log(produtos.data)

            if (produtos.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(produtos.msg || "")

            } else {

                setProdutosEstoque(produtos.data)

                const somaTotalCusto = produtos.data.reduce((total: number, item: any) => {
                    return total + Number(item.total_custo);
                }, 0);

                const somaTotalVenda = produtos.data.reduce((total: number, item: any) => {
                    return total + Number(item.total_venda);
                }, 0);

                setTotalProdutos(produtos.data.length)
                setTotalPrecoCusto(Funcoes.numberFormat(somaTotalCusto, 'currency', 2, 2))
                setTotalPrecoVenda(Funcoes.numberFormat(somaTotalVenda, 'currency', 2, 2))

            }


        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar os produtos`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 1500)
        }

    }

    const limparCampoFilter = () => {
        setFilter("")
    }

    const handleLimparFiltros = () => {

        setFilter("")
        setIdMarca(0)
        setNomeMarca('')
        setIdGrupo(0)
        setNomeGrupo('')

        setAtivo("")
        setEstoqueFisico("")

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        searchBoxFocus()
    }

    const handleChangeField = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const fieldMap: { [key: string]: string } = {
            'descricao': 'descricao',
        }

        const selectedField = fieldMap[e.target.value]

        if (selectedField) {
            setField(selectedField)
        }
    }

    const handleFilterTypeChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {

        const filterMap: { [key: string]: string } = {
            'start': 'start',
            'equals': 'equals',
            'contains': 'contains',
        }

        const selectedFilter = filterMap[e.target.value]

        if (selectedFilter) {
            setFilterType(selectedFilter)
        }
    }

    const handleChangeFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value)
    }

    const ativoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setAtivo(e.target.value)
        //setbtImpDisabled(true)
        e.currentTarget.blur()
    }

    const estoqueFisicoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setEstoqueFisico(e.target.value)
        //setbtImpDisabled(true)
        e.currentTarget.blur()
    }

    //-------------------------------------------------------------------- PDF ---------------------------------------------------------------------------------------//
    const handleGerarPDFClick = async (event: any) => {
        try {
            
            const pdf = new RelProdutosEstoquePDF(produtosEstoque, totalProdutos, totalPrecoVenda, totalPrecoCusto)
            pdf.GerarPDF(produtosEstoque)

            event.currentTarget.blur()

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Ocorreu um erro ao imprimir. Por favor, tente novamente`)
        }

    }

    //-------------------------------------------------------------------- MARCAS ------------------------------------------------------------------------------------//
    const handleClearMarcaSelecionada = useCallback(() => {
        const newMarcaList = [...prodAttributes?.marcas || []]
        setMarcas(newMarcaList)
        setIdMarca(0)
        setNomeMarca('')

        setVisibleSearchBoxMarca(false)

        //setbtImpDisabled(true)
    }, [prodAttributes?.marcas])

    const handleFilterMarcasClick = useCallback(async (description: string) => {

        if (description === "") {

            const newMarcaList = [...prodAttributes?.marcas || []]
            setMarcas(newMarcaList || [])

        } else {

            const newMarcaList = [...prodAttributes?.marcas || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setMarcas(newMarcaList || [])
        }

    }, [prodAttributes?.marcas])

    const handleMarcasSelectClick = useCallback((v: Marca) => {

        if (v) {
            const newMarcaList = [...prodAttributes?.marcas || []]
            setMarcas(newMarcaList)
            setIdMarca(v.id)
            setNomeMarca(v.description)
        }

        setVisibleSearchBoxMarca(false)
        //setbtImpDisabled(true)
    }, [prodAttributes?.marcas])

    const clickSearchBoxMarca = useCallback(() => {
        setVisibleSearchBoxMarca((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no SearchBoxMarca
                setVisibleSearchBoxGrupo(false)
                inputFocusMarca()
            }
            return newState
        })
    }, [])

    const inputFocusMarca = () => {
        let inputSearch = document.getElementById(`inputSearchBox-marca`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //-------------------------------------------------------------------- GRUPOS ------------------------------------------------------------------------------------//
    const handleClearGrupoSelecionada = useCallback(() => {
        const newGrupoList = [...prodAttributes?.grupos || []]
        setGrupos(newGrupoList)
        setIdGrupo(0)
        setNomeGrupo('')

        setVisibleSearchBoxGrupo(false)

        //setbtImpDisabled(true)
    }, [prodAttributes?.grupos])

    const handleFilterGruposClick = useCallback(async (description: string) => {

        if (description === "") {

            const newGrupoList = [...prodAttributes?.grupos || []]
            setGrupos(newGrupoList || [])

        } else {

            const newGrupoList = [...prodAttributes?.grupos || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setGrupos(newGrupoList || [])
        }

    }, [prodAttributes?.grupos])

    const handleGruposSelectClick = useCallback((v: Grupo) => {

        if (v) {
            const newGrupoList = [...prodAttributes?.grupos || []]
            setGrupos(newGrupoList)
            setIdGrupo(v.id)
            setNomeGrupo(v.description)
        }

        setVisibleSearchBoxGrupo(false)

        //setbtImpDisabled(true)
    }, [prodAttributes?.grupos])

    const clickSearchBoxGrupo = useCallback(() => {
        setVisibleSearchBoxGrupo((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no SearchBoxGrupo
                setVisibleSearchBoxMarca(false)
                inputFocusGrupo()
            }
            return newState
        })
    }, [])

    const inputFocusGrupo = () => {
        let inputSearch = document.getElementById(`inputSearchBox-grupo`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div id='div-body' className={`${classDivBody}`}>

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-12 sm:col-span-6 xl:col-span-8 flex flex-row items-center`}>
                            <HiOutlineClipboardDocumentList className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Relatório de Produtos em Estoque</span>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-3 xl:col-span-2`}>
                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro}>
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-3 xl:col-span-2`}>
                            <button tabIndex={-1} className={`${classBtSemDuration} ${classbtCeuAzul} h-9 disabled:opacity-50 disabled:cursor-not-allowed`} disabled={!(produtosEstoque.length > 0)} onClick={handleGerarPDFClick} >
                                <IoPrint size="20px" className='hidden mr-2 md:block' /> Imprimir
                            </button>
                        </div>

                    </div>

                    <div id='divInputsProdEstoque' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroProdEstoque' className={`relative max-h-[0px] h-[600px] sm:h-[300px] xl:h-[230px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-3 py-7 px-3`}>

                            <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2 mt-3 sm:mt-0`}>
                                <select disabled={loading} id='filter_to' className={`${classInput} ${classInputDark} `} value={field} onFocus={searchBoxFocus} onChange={handleChangeField}>
                                    <option value="descricao">DESCRIÇÃO</option>
                                </select>
                                <label htmlFor="filter_to" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}><Icone icon={faFilter} /><span className={`ml-2`}>Filtrar por</span></label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2 mt-3 sm:mt-0`}>
                                <select disabled={loading} id='filter_type' className={`${classInput} ${classInputDark} `} value={filterType} onFocus={searchBoxFocus} onChange={handleFilterTypeChange}>
                                    <option value="start">INICIA COM</option>
                                    <option value="equals">IGUAL A</option>
                                    <option value="contains">CONTÉM</option>
                                </select>
                                <label htmlFor="filter_type" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Critério</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-6 xl:col-span-8 mt-3 sm:mt-0`}>
                                <input id='pesquisa_produto_estoque' className={`${classInput} ${classInputDark} pr-10`} maxLength={field === 'ncm' ? 8 : 999} placeholder=' ' autoComplete="off" value={filter} onFocus={searchBoxFocus} onChange={handleChangeFilter} />
                                <label htmlFor="pesquisa_produto_estoque" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Digite sua consulta</label>
                                <button onClick={limparCampoFilter} className={`absolute right-2 bottom-0 top-0 text-slate-400 outline-none ${filter === '' ? 'invisible' : 'visible'}`}>
                                    <IoCloseCircleOutline size="25px" />
                                </button>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-3`}>
                                <select id="ativo" className={`${classInput} ${classInputDark}  ${ativo === "" ? `text-blue-500 dark:text-cyan-300` : ``}`} value={ativo} onFocus={searchBoxFocus} onChange={ativoChange}>
                                    <option value="" className={`text-blue-500 dark:text-cyan-300`}>( selecione )</option>
                                    <option value="S" className={`text-slate-900 dark:text-slate-200`}>Sim</option>
                                    <option value="N" className={`text-slate-900 dark:text-slate-200`}>Não</option>
                                </select>

                                <label htmlFor="ativo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Ativo</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-3`}>
                                <select id="estoque" className={`${classInput} ${classInputDark} ${estoqueFisico === "" ? `text-blue-500 dark:text-cyan-300` : ``}`} value={estoqueFisico} onFocus={searchBoxFocus} onChange={estoqueFisicoChange}>
                                    <option value="" className={`text-blue-500 dark:text-cyan-300`}>( selecione )</option>
                                    <option value="0" className={`text-slate-900 dark:text-slate-200`}>Com Estoque</option>
                                    <option value="1" className={`text-slate-900 dark:text-slate-200`}>Sem Estoque</option>
                                    <option value="2" className={`text-slate-900 dark:text-slate-200`}>Estoque Negativo</option>
                                    <option value="3" className={`text-slate-900 dark:text-slate-200`}>Atingiu o Estoque Mínimo</option>
                                </select>

                                <label htmlFor="estoque" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Estoque</label>
                            </div>

                            <div id='componenteMarca' className={`relative col-span-12 sm:col-span-4 xl:col-span-3 mt-3`}>
                                <SearchBox
                                    dataList={marcas}
                                    idRegistro={idMarca || undefined}
                                    label='Marca'
                                    componentId='marca'
                                    visibleTAB={visibleSearchBoxMarca}
                                    setDataClick={handleMarcasSelectClick}
                                    clearDataClick={handleClearMarcaSelecionada}
                                    filterDataClick={handleFilterMarcasClick}
                                    clicado={clickSearchBoxMarca}
                                />
                            </div>

                            <div id='componenteGrupo' className={`relative col-span-12 sm:col-span-4 xl:col-span-3 mt-3`}>
                                <SearchBox
                                    dataList={grupos}
                                    idRegistro={idGrupo || undefined}
                                    label='Grupo'
                                    componentId='grupo'
                                    visibleTAB={visibleSearchBoxGrupo}
                                    setDataClick={handleGruposSelectClick}
                                    clearDataClick={handleClearGrupoSelecionada}
                                    filterDataClick={handleFilterGruposClick}
                                    clicado={clickSearchBoxGrupo}
                                />
                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-3`}>

                                <div className={`relative mt-2 sm:mt-0`}>
                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={handleLimparFiltros}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>
                                    <button disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFilterClick} >
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>
                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 bg-white dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>
                        <GridProductsEstoque produtoEstoque={produtosEstoque} />
                    </div>

                </div>

            </div>

        </Template>
    )
}